module.exports = __webpack_public_path__ + "media/images/map-icons/pet-f6dab0fcf8d3e05beeb5aa0a5cac3483.svg";